<template>
	<div id="app" :class="{ 'app--development': isDevelopment }">
		<div
			class="layout--main"
			:class="{
				'inside': hasPermission
			}"
		>
			<Header v-if="hasPermission"/>

			<main
				id="main"
				:class="{
					'development': isDevelopment,
					'router-view': hasPermission
				}">
				<router-view />
			</main>
		</div>
	</div>
</template>

<script>
import themeConfig from "../themeConfigs";
import config from "./config";

import Header from "./layouts/header/Header";

export default {
	data() {
		return {
			hasRoute: false,
			hasPermission: false,
			versao: config.version
		};
	},
	components: {
		Header
	},
	computed: {
		isDevelopment() {
			return config.mode === "development";
		},

		currentYear() {
			const date = new Date();
			const year = date.getFullYear();
			return year;
		}
	},
	methods: {
		setHasPermission() {
			const hasPermission = !this.$permissions.can("public");

			this.hasPermission = hasPermission;
		},

		setHasRoute() {
			if (!this.hasRoute) {
				this.hasRoute = true;
			}
		},
		toggleClassInBody(className) {
			if (className == "dark") {
				if (document.body.className.match("theme-semi-dark"))
					document.body.classList.remove("theme-semi-dark");
				document.body.classList.add("theme-dark");
			} else if (className == "semi-dark") {
				if (document.body.className.match("theme-dark"))
					document.body.classList.remove("theme-dark");
				document.body.classList.add("theme-semi-dark");
			} else {
				if (document.body.className.match("theme-dark"))
					document.body.classList.remove("theme-dark");
				if (document.body.className.match("theme-semi-dark"))
					document.body.classList.remove("theme-semi-dark");
			}
		}
	},
	watch: {
		$route() {
			this.setHasRoute();
			this.setHasPermission();
		}
	},
	mounted() {
		this.toggleClassInBody(themeConfig.theme);
	}
};
</script>
